<div class="modal-wrapper">

    <div class="modal-header">
        <h1 class="modal-title">New Collaborator</h1>
        <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body">
        <ng-template #showLoader>
            <div class="loader-container">
                <div class="spinner-border"></div>
            </div>
        </ng-template>
        <div class="form-container" *ngIf='!loader; else showLoader'>
            <form [formGroup]='addNewUserForm' (submit)='onSubmit()' novalidate>
            <div class="form-group dropdown-typeahead-container" style="margin-bottom: 2%;">
                <label class="input-title" for="email"
                    [class.text-error]="submitted && newUserForm.email.invalid">Collaborators</label>
                <input id="email" type="email" class="form-control" formControlName="email" [ngbTypeahead]="search"
                    placeholder="Start typing an email address.." [resultTemplate]="userCollaborator"
                    [inputFormatter]="formatter" [resultFormatter]="formatter"
                    (selectItem)='getSelectedItem($event)'
                    [class.is-invalid]="submitted && newUserForm.email.invalid"
                    [class.is-valid]="submitted && newUserForm.email.valid" />
                <ng-template #userCollaborator let-user="result" let-t="term">
                    <img *ngIf="user.name !== ''; else noUserImg" class="action-icon rounded-circle profile-img"
                        [src]="user.thumbnail | authImage | async">
                    <ng-template #noUserImg>
                        <div class="action-icon rounded-circle profile-img"></div>
                    </ng-template>
                    <div class="user-info-wrapper">
                        <div class="user-info-container">
                            <p class="name">{{user.name !== '' ? (user.name + ' ' + user.surname) : 'External
                                user'}}</p>
                            <p class="email">
                                <ngb-highlight [result]="user.email" [term]="t" *ngIf="user.name !== ''">
                                </ngb-highlight>
                                <span *ngIf="user.name === ''">{{newUserForm.email.value}}</span>
                            </p>
                        </div>
                        <i class="ic-share"></i>
                    </div>
                </ng-template>
                <small class="invalid-feedback text-error" *ngIf="newUserForm.email.errors">
                    <span *ngIf="newUserForm.email.errors.required">Email is mandatory. Please fill the
                        field!</span>
                    <span *ngIf="newUserForm.email.errors.pattern">Email is invalid. Please insert valid
                        format!</span>
                </small>
            </div>
            <div class="input-extra-container" *ngIf='showFormExtra'>
                <div class="form-group">
                    <label for='name' class="input-title"
                        [class.text-error]="submitted && newUserForm.name.invalid">Name</label>
                    <input name="name" required class="form-control" type="text" formControlName="name"
                        placeholder="Insert name" [class.is-invalid]="submitted && newUserForm.name.invalid"
                        [class.is-valid]="submitted && newUserForm.name.valid">
                    <small class="invalid-feedback text-error">Name is mandatory. Please fill the field!</small>
                </div>
                <div class="form-group">
                    <label for='name' class="input-title"
                        [class.text-error]="submitted && newUserForm.surname.invalid">Surname</label>
                    <input name="surname" required class="form-control" type="text" placeholder="Insert surname"
                        formControlName="surname" [class.is-invalid]="submitted && newUserForm.surname.invalid"
                        [class.is-valid]="submitted && newUserForm.surname.valid">
                    <small class="invalid-feedback text-error">Surname is mandatory. Please fill the field!</small>
                </div>
                <div class="form-group">
                    <label for='company' class="input-title"
                        [class.text-error]="submitted && newUserForm.company.invalid">Organization</label>
                    <ng-select required bindLabel='name' bindValue='guid' [clearable]="false"
                        class="custom ng-select ng-select-single" formControlName="company"
                        placeholder='Select or create an organization...' [items]="companiesAvailable"
                        (change)="filterRoles()" [class.is-invalid]="submitted && newUserForm.company.invalid"
                        [class.is-valid]="submitted && newUserForm.company.valid">
                        <ng-template ng-footer-tmp>
                            <div class="create-new d-flex align-items-center"
                                (click)="openCreateNewOrganizationModal()">
                                <i class="ic-add ic-size-20"></i>Create new organization
                            </div>
                        </ng-template>
                    </ng-select>
                    <small class="invalid-feedback text-error"
                        *ngIf="submitted && newUserForm.company.invalid && !isCreatingNew">Organization is
                        mandatory. Please fill the field!</small>
                    <small *ngIf="isCreatingNew">Creating and loading new organization... </small>
                </div>
            </div>
            <!-- <div class="user-info"></div> -->
            <span class=" input-title">Invite as</span>
            <div class="dropdown first" style="margin-bottom: 5%;">
                <button class="btn dropdown-toggle role-button" type="button" id="dropdownMenuButton1"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{roleSelected | titlecase}}
                </button>
                <div ngbDropdown class="dropdown">
                    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownRole">
                        <a class="dropdown-item" *ngFor="let role of rolesAvailable; let i = index"
                            (click)='getSelectedRole(role)'>
                            <p class="name" [class.active]="role.role === roleSelected">{{role.role | titlecase}}
                            </p>
                            <p class="email" *ngIf='role.description'>{{role.description}}</p>
                        </a>
                    </div>
                </div>
            </div>
        </form>
            <div *ngFor="let specific_tool of jobsPrivilegesAvailable" >
                <div *ngIf="specific_tool?.tool_informations?.label" class="row">
                    <div class="col-4">
                        {{specific_tool?.tool_informations?.label}}
                    </div>
                    <div class="col-8">
                        <button class="btn p-0 role-button dropdown-toggle" type="button" id="dropdownRole"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{(specific_tool?.access_level ? specific_tool?.access_level : 'No Access') | titlecase}}
                        </button>
                        <div ngbDropdown class="dropdown">
                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right"
                                aria-labelledby="dropdownRole">
                                <a class="dropdown-item"
                                    *ngFor="let role of specific_tool?.possible_access_levels; let i = index"
                                    (click)="changeUserRole(specific_tool, role)">
                                    <div>
                                        <p class="name"
                                            [ngClass]="{'active-role': role == specific_tool?.access_level}">{{role |
                                            titlecase}}</p>
                                    </div>
                                </a>
                                <a *ngIf="specific_tool?.access_level" class="dropdown-item"
                                    (click)="changeUserRole(specific_tool, null)">
                                    <div *ngIf="role == null">
                                        <p class="name">Remove access to {{specific_tool?.tool_informations?.tool_name}}
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-container" class="my-2">
                <div class="form-group" *ngIf=' data?.selector !== "share" '>
                    <div class="d-flex justify-content-between">
                        <label class="input-title-bott">
                            Special Property: 
                        </label>
                    <button class="btn btn-secondary ml-3" type="button" (click)="addProperty()">Add Property</button>
                    </div>
                    <div class="dropdown first custom" class="ml-1">
                        <div *ngFor="let p of special_property; let in = index;trackBy:trackByIdx">
                            <div class="input-group input-group-sm mb-3 mt-4">
                                <input type="text" class="form-control" placeholder="Property Name" aria-label="Name"
                                    aria-describedby="basic-addon1" [(ngModel)]="p.key">
                                <input type="text" class="form-control" placeholder="Property Value" aria-label="Value"
                                    aria-describedby="basic-addon1" [(ngModel)]="p.value">
                                <i class="ic-close" style="font-size: 2.5rem;" (click)="deleteProperty(in)"></i>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    
    <div class="modal-footer pt-5">
        <button type="button" class="btn btn-outline-dark" (click)="onDelete(f)">Cancel</button>
        <button class="btn btn-default ml-3" type='submit' (click)="onSubmit()">Invite</button>
    </div>



</div>